import r from "../../shared-lib/braze-shared-lib.js";
import { ControlCard } from "../Card/index.js";
export const FEED_ANIMATION_DURATION = 500;
export default class x {
  constructor(s, e) {
    (this.cards = s),
      (this.lastUpdated = e),
      (this.cards = s),
      (this.lastUpdated = e);
  }
  getUnreadCardCount() {
    let s = 0;
    for (const e of this.cards) e.viewed || e instanceof ControlCard || s++;
    return s;
  }
  ur() {
    r.j.error("Must be implemented in a subclass");
  }
  logCardImpressions(s) {
    r.j.error("Must be implemented in a subclass");
  }
  logCardClick(s) {
    r.j.error("Must be implemented in a subclass");
  }
  sr() {
    r.j.error("Must be implemented in a subclass");
  }
}
(x.mr = 6e4), (x.Oh = 500), (x.uo = 1e4);
